import StepSchedulingType from '../steps/common/step_scheduling_type';
import StepShipping from '../steps/common/step_shipping';
import type { IStep2 } from '../wizard';

export const methodStepName = 'shippingMethodSelection';
export const insertInfoStepName = 'shippingInsertInfo';

export const schedulingStepName = methodStepName;
export const schedulingStepsNames = [methodStepName, insertInfoStepName];

const schedulingType: IStep2 = {
  comp: StepSchedulingType,
  name: schedulingStepName,
  caption: 'Last steps',
  title: 'Shipping',
  disableBackButton: true,
  disappearFromProgressBar: false,
  disableProgressBar: true,
  exits: {
    next: insertInfoStepName,
  },
};

const shipping: IStep2 = {
  comp: StepShipping,
  name: insertInfoStepName,
  caption: '[shipping_type]',
  title: 'Shipping',
  disableBackButton: true,
  disappearFromProgressBar: true,
  disableProgressBar: true,
  exits: {},
  final: true,
};

export const shippingSchedulingSteps = [
  schedulingType,
  shipping,
];
